
import React from 'react';
import { Star } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

const TestimonialSection = () => {
  const testimonials = [
    {
      quote: "Pensé que iba a perder mi residencia. Ahora sé qué hacer. Gracias Migrante Amigo.",
      author: "Rosa G., Phoenix, AZ",
      rating: 5
    },
    {
      quote: "Mi esposo y yo estábamos perdidos con el proceso de ciudadanía. Esta app nos dio la claridad que necesitábamos.",
      author: "María C., Los Angeles, CA",
      rating: 5
    },
    {
      quote: "Finalmente encontré respuestas claras sobre mi caso de asilo. Me siento más seguro ahora.",
      author: "Carlos M., Houston, TX",
      rating: 5
    }
  ];

  const TestimonialCard = ({ testimonial }: { testimonial: typeof testimonials[0] }) => (
    <div className="bg-[#FAF9F6] rounded-2xl p-6 sm:p-8 shadow-lg h-full">
      <div className="flex justify-center mb-4">
        <div className="flex gap-1">
          {[...Array(testimonial.rating)].map((_, i) => (
            <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
          ))}
        </div>
      </div>
      
      <blockquote 
        className="text-lg sm:text-xl font-medium text-gray-900 mb-6 leading-relaxed text-center"
        style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
      >
        "{testimonial.quote}"
      </blockquote>
      
      <cite 
        className="text-base text-gray-600 font-medium text-center block"
        style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
      >
        – {testimonial.author}
      </cite>
    </div>
  );

  return (
    <section className="py-12 sm:py-16 px-4 sm:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
          >
            Lo que dicen nuestros usuarios
          </h2>
          <p 
            className="text-base text-gray-600"
            style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
          >
            Más de 2,000 migrantes ya usan MigranteAmigo cada mes.
          </p>
        </div>

        {/* Mobile Carousel */}
        <div className="block lg:hidden relative">
          <Carousel
            opts={{
              align: "center",
              loop: true,
            }}
            className="w-full max-w-sm mx-auto"
          >
            <CarouselContent>
              {testimonials.map((testimonial, index) => (
                <CarouselItem key={index} className="basis-full">
                  <TestimonialCard testimonial={testimonial} />
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="left-4 top-3/4 -translate-y-1/2" />
            <CarouselNext className="right-4 top-3/4 -translate-y-1/2" />
          </Carousel>
        </div>

        {/* Desktop Grid */}
        <div className="hidden lg:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} testimonial={testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
